import React from 'react';
import { useSelector } from 'react-redux';
import { ErrorBoundary, PostMetaHeaderTags } from 'mm-ui-components';
import {
    getAmpURL,
    getCanonicalUrl,
    getFacebookAppId,
    getFacebookPageId,
    getFavicon,
    getLogoUrl,
    getPageDescription,
    getPageTitle,
    getPrevCanonicalUrl,
    getSiteName,
    getTwitterAccount,
} from '../../store/config/config.selectors';
import {
    getAuthors,
    getCreatedAt,
    getImageCover,
    getNoIndex,
    getUpdatedAt,
    getOgDescription,
    getOgTitle,
    getOgImage,
    getTwitterDescription,
    getTwitterTitle,
    getTwitterImage,
} from '../../store/template/postPage/postPage.selectors';

export const PostMetaTagsConnected: React.FunctionComponent = () => {
    const facebookAppId = useSelector(getFacebookAppId);
    const facebookPageId = useSelector(getFacebookPageId);
    const pageDescription = useSelector(getPageDescription);
    const siteName = useSelector(getSiteName);
    const canonicalUrl = useSelector(getCanonicalUrl);
    const favicon = useSelector(getFavicon);
    const pageTitle = useSelector(getPageTitle);
    const twitterAccount = useSelector(getTwitterAccount);
    const pageImage = useSelector(getImageCover);
    const logoUrl = useSelector(getLogoUrl);
    const authors = useSelector(getAuthors);
    const createdAt = useSelector(getCreatedAt);
    const updatedAt = useSelector(getUpdatedAt);
    const ampURL = useSelector(getAmpURL);
    const prevCanonicalUrl = useSelector(getPrevCanonicalUrl);
    const noIndex = useSelector(getNoIndex);
    const ogDescription = useSelector(getOgDescription);
    const ogTitle = useSelector(getOgTitle);
    const ogImage = useSelector(getOgImage);
    const twitterDescription = useSelector(getTwitterDescription);
    const twitterTitle = useSelector(getTwitterTitle);
    const twitterImage = useSelector(getTwitterImage);
    return (
      <PostMetaHeaderTags {...{
            facebookAppId,
            facebookPageId,
            pageDescription,
            siteName,
            canonicalUrl,
            favicon,
            pageTitle,
            twitterAccount,
            pageImage,
            logoUrl,
            authors,
            createdAt,
            updatedAt,
            ampURL,
            prevCanonicalUrl,
            noIndex,
            ogDescription,
            ogTitle,
            ogImage,
            twitterDescription,
            twitterTitle,
            twitterImage,
        }}
      />
    );
};
export const PostMetaTags = () => <ErrorBoundary><PostMetaTagsConnected /></ErrorBoundary>;
